module.exports = __webpack_public_path__ + "img/exemption.d24a96cf.png";